import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getScheduleListApi, scheduleDeleteApi } from "../../api";
import { setScheduleList, scheduleDelete } from "../../redux";
import { FaPen, FaTrashAlt } from "react-icons/fa";
import Cookies from "js-cookie";
import { Schedule } from "./";
import { withRouter } from "react-router-dom";
import { FiZap, FiClock, FiCalendar, FiRepeat, FiArrowLeft } from "react-icons/fi";
import { useTranslation } from "react-i18next";

const ScheduleListComp = (props) => {
  const { t } = useTranslation();
  var daysFA = [
    t("شنبه"),
    t("یکشنبه"),
    t("دوشنبه"),
    t("سه شنبه"),
    t("چهارشنبه"),
    t("پنجشنبه"),
    t("جمعه"),
  ];

  const { zone } = props;
  const token = Cookies.get("token");
  const dispatch = useDispatch();
  const scheduleList = useSelector((state) => state.scheduleList.scheduleList);
  const [openScheduleModal, setOpenScheduleModal] = useState(false);
  const toggleSchedule = () => setOpenScheduleModal(!openScheduleModal);
  const [scheduleData, setScheduleData] = useState();
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });

  useEffect(() => {
    const data = new FormData();
    data.append("serial", zone.serial);
    data.append("widget", zone.id);
    getScheduleListApi(data, token)
      .then((res) => {
        dispatch(setScheduleList(res.data.data));
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
            type: "Error",
          }));
          setTimeout(() => {
            setShowAlert((prevState) => ({
              ...prevState,
              show: false,
            }));
          }, 2000);
        }
      });
  }, []);

  const deleteSchedule = (id) => {
    const data = new FormData();
    data.append("schedule", id);
    scheduleDeleteApi(data, token)
      .then(() => {
        dispatch(scheduleDelete({ id: id }));
        setShowAlert({
          show: true,
          message: t("زمان بندی با موفقیت حذف شد"),
          type: "Success",
        });
        setTimeout(() => setShowAlert((prev) => ({ ...prev, show: false })), 2000);
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
        }
      });
  };

  const editSchedule = (value) => {
    toggleSchedule();
    setScheduleData(value);
  };

  return (
    <div className="setting-container" style={{ minHeight: "auto", padding: "20px" }}>
      {!openScheduleModal ? (
        <>
          <h2 className="setting-title">{t("لیست زمانبندی ها")}</h2>

          {/* Zone Info */}
          <div className="schedule-command-info" style={{ marginBottom: "20px" }}>
            <div className="schedule-command-icon">
              <FiZap size={24} />
            </div>
            <div>
              <p className="schedule-command-label">{zone.caption}</p>
              <p className="schedule-zone-name">{t("ویجت")}</p>
            </div>
          </div>

          {/* Schedule List */}
          {scheduleList === null || scheduleList?.length === 0 ? (
            <div className="empty-state">
              <FiClock size={48} />
              <p>{t("زمانبندی برای این ویجت تعریف نشده است.")}</p>
            </div>
          ) : (
            <div className="schedule-list-container">
              {scheduleList?.map((schedule, index) => {
                let days = schedule.days?.split(",") || [];
                const isOn = schedule.command == "11";
                
                return (
                  <div key={index} className="schedule-card">
                    {/* Header with Icon and Command */}
                    <div className="schedule-card-header">
                      <div className="schedule-card-icon">
                        <FiZap size={20} />
                      </div>
                      <p className="schedule-card-command">
                        {isOn ? t("خروجی 1 - خاموش") : t("خروجی 1 - روشن")}
                      </p>
                    </div>

                    {/* Details */}
                    <div className="schedule-card-details">
                      <div className="schedule-detail-item">
                        <FiCalendar size={14} />
                        <span className="detail-label">{t("تاریخ ثبت")}</span>
                        <span className="detail-value">{schedule.start_date || "---"}</span>
                      </div>
                      <div className="schedule-detail-item">
                        <FiClock size={14} />
                        <span className="detail-label">{t("ساعت اجرا")}</span>
                        <span className="detail-value">{schedule.time}</span>
                      </div>
                      <div className="schedule-detail-item">
                        <FiRepeat size={14} />
                        <span className="detail-label">{t("روزهای اجرا")}</span>
                        <div className="schedule-days">
                          {days.map((day, idx) => (
                            <span key={idx} className="schedule-day-badge">
                              {daysFA[day - 1]}
                            </span>
                          ))}
                        </div>
                      </div>
                    </div>

                    {/* Action Buttons */}
                    <div className="schedule-card-actions">
                      <button
                        className="schedule-edit-btn"
                        onClick={() => editSchedule(schedule)}
                        title={t("ویرایش")}
                      >
                        <FaPen size={14} />
                        <span>{t("ویرایش")}</span>
                      </button>
                      <button
                        className="schedule-delete-btn"
                        onClick={() => deleteSchedule(schedule.id)}
                        title={t("حذف")}
                      >
                        <FaTrashAlt size={14} />
                        <span>{t("حذف")}</span>
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </>
      ) : (
        <Schedule
          zone={zone}
          toggleSchedule={toggleSchedule}
          scheduleData={scheduleData}
        />
      )}

      {showAlert.show && (
        <div className={`alert-custom ${showAlert.type === "Success" ? "alert-success" : "alert-error"}`}>
          {showAlert.message}
        </div>
      )}
    </div>
  );
};

const ScheduleList = withRouter(ScheduleListComp);

export { ScheduleList };